import React from "react"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"

import Image from "@atoms/Image/Image"
import Placeholder from "@atoms/Placeholder/Placeholder"

import styles from "./ContactCard.module.scss"

const ContactCard = ({ name, text, image, phone, email }) => {
  const aspectRatio = "7:5"
  return (
    <div className={`${styles.element} make-full-width-on-mobile`}>
      <Row className="no-gutters mobile-bottom-margins tablet-bottom-margins">
        <Col lg={{ span: 6 }}>
          <div className={styles.image}>
            {image && (
              <Image
                image={image}
                aspectRatio={aspectRatio}
                widths={[313, 612, 750, 1080]}
                fill={true}
              />
            )}
            {!image && <Placeholder aspectRatio={aspectRatio} />}
          </div>
        </Col>

        <Col lg={{ span: 6 }} className="align-self-center">
          <div
            className={`${styles.content} make-full-width-on-mobile-with-paddings`}
          >
            <h2>{name}</h2>
            <p>{text}</p>
            {(phone || email) && (
              <ul>
                {phone && <li>{phone}</li>}
                {email && (
                  <li>
                    <a href={`mailto:${email}`}>{email}</a>
                  </li>
                )}
              </ul>
            )}
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default ContactCard

ContactCard.defaultProps = {
  variant: "regular",
}
